__turbopack_context__.v({
  "bottom-spacing": "-WWO7q_bottom-spacing",
  "wrapper": "-WWO7q_wrapper",
});
